import { CartItemUpdateSlice } from './types'

export const getCartItemUpdate = (itemId: string) => (state: any) => {
  const slice: CartItemUpdateSlice = state.quote.cartItemUpdate[itemId]
  return slice ?? {}
}
